import React from 'react';
import PropTypes from 'proptypes';
import { slide as Menu } from 'react-burger-menu';
import { Link } from 'react-router-dom';

import { MainNavComponent as MainNav } from 'components/main-nav';
import { FooterNavComponent as FooterNav } from 'components/footer-nav';
import { IconComponent as Icon } from 'components/icon';

import logo from 'static/logos/main-logo.svg';
import burgerIcon from 'static/icons/svg/menu-button.svg';
import clearIcon from 'static/icons/svg/clear-button.svg';

const styles = require('./burger-menu-component.styles.scss');


export class BurgerMenuComponent extends React.Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    onStateChange: PropTypes.func,
  }

  static defaultProps = {
    onStateChange: () => {},
  }

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  render() {
    const burgerIconComponent = (
      <Icon className={styles.BurgerButton} src={burgerIcon} />
    );
    const clearIconComponent = (
      <Icon className={styles.CrossButton} src={clearIcon} />
    );

    return (
      <Menu right
        burgerButtonClassName={styles.BurgerButton}
        burgerBarClassName={styles.BurgerBar}
        crossButtonClassName={styles.CrossButton}
        crossClassName={styles.Cross}
        menuClassName={styles.Menu}
        width={ 240 }
        isOpen={this.props.isOpen}
        onStateChange={this.onMenuStateChange}
        customBurgerIcon={burgerIconComponent}
        customCrossIcon={clearIconComponent}
      >
        <div className={styles.LogoContainer}>
          <Link to='/' onClick={this.onNavigate}>
            <Icon src={logo} className={styles.LogoIcon} />
          </Link>
        </div>
        <MainNav display='column' onNavigate={this.onNavigate} />
        <FooterNav display='column' onNavigate={this.onNavigate} />
      </Menu>
    );
  }

  setMenuState(bool) {
    const { onStateChange } = this.props;
    if (onStateChange) { onStateChange(bool); }
  }

  onNavigate = (event) => {
    event.stopPropagation();

    this.setMenuState(false);
  }

  onMenuStateChange = (state) => {
    this.setMenuState(state.isOpen);
  }
}



// WEBPACK FOOTER //
// ./src/components/menus/burger-menu/burger-menu.component.jsx